import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AppLauncherService } from '../../services/app-launcher.service';

export interface SsoRedirectDialogData {
  appTitle: string;
  trigram: string;
}

type RedirectPhase = 'confirm' | 'success' | 'wip';

// Diálogo único (confirm → success, ou wip) reaproveitado por qualquer botão de aplicação da homepage.
@Component({
  standalone: true,
  selector: 'app-sso-redirect-dialog',
  templateUrl: 'sso-redirect-dialog.component.html',
  styleUrl: 'sso-redirect-dialog.component.scss',
  imports: [CommonModule, MatIconModule]
})
export class SsoRedirectDialogComponent {
  phase: RedirectPhase;

  constructor(
    private readonly dialogRef: MatDialogRef<SsoRedirectDialogComponent>,
    private readonly appLauncher: AppLauncherService,
    @Inject(MAT_DIALOG_DATA) public data: SsoRedirectDialogData
  ) {
    this.phase = this.appLauncher.hasUrl(this.data.trigram) ? 'confirm' : 'wip';
  }

  cancel(): void {
    this.dialogRef.close();
  }

  get icon(): string {
    return { confirm: 'sync', success: 'check', wip: 'construction' }[this.phase];
  }

  // Não fecha nem recria o diálogo: só troca o conteúdo (ngSwitch) p/ a fase de sucesso, no mesmo diálogo.
  confirm(): void {
    this.phase = 'success';

    setTimeout(() => {
      this.dialogRef.close();
      this.appLauncher.open(this.data.trigram);
    }, 1200);
  }
}
